import React from 'react';

import { useSelector } from 'react-redux';

import {
    Text,
} from 'wanderu-components';
import { localize, i18nMoment as ourMoment, selectLocale } from 'wanderu-i18n';

import { LineItem } from '../../LineItem';
import { TripLeg } from '../TripLeg';

import styles from './TripDetails.scss';

import type { TripLegItems } from '../../types';
import type { TFunction } from 'i18next';

interface TripDetailsProps {
    i18nMoment: typeof ourMoment;
    isReturnTrip: boolean;
    legs: TripLegItems[];
    t: TFunction;
}

function TripDetails({
    i18nMoment,
    isReturnTrip,
    legs,
    t,
}: TripDetailsProps) {
    const locale = useSelector(selectLocale);
    const trip = legs[0];

    const {
        localizedDepartDateTime,
    } = trip;

    const tripDirection = isReturnTrip
        ? 'return'
        : 'departure';

    const date = i18nMoment.parseZone(localizedDepartDateTime).shortDateTimestamp();

    return (
        <div>
            <LineItem
                leftCol={
                    <Text className={styles.left} variant="text-s" bold>
                        {t(tripDirection)}
                    </Text>
                }
                leftColStyles={styles.lineItem}
                rightCol={
                    <Text className={styles.right} data-testid="date" variant="text-xs" bold>
                        {date}
                    </Text>
                }
                rightColStyles={styles.lineItem}
            />
            {legs?.map((leg) => (
                <TripLeg
                    key={leg.tripId}
                    locale={locale}
                    {...leg}
                />
            ))}
        </div>
    );
}

export { TripDetails };

export default localize(TripDetails, ['i18nMoment', 't'], 'baseApp');
